var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"exporo-gallery-button"},[_c('a',{attrs:{"href":"#stage-gallery","id":"open-gallery"},on:{"click":function($event){return _vm.openGallery()}}},[_vm._v("Galerie")])])}
var staticRenderFns = []

export { render, staticRenderFns }